<template>
  <div class="view-home">
    <header-preview
      v-if="course_data"
      :module="course_data"
      :additional-info="additionalInfo"
      :lesson="lastLesson"
      :description="$setup.setup.description"
      show-certificate
      :lastLessons="lastLessons"
    />

    <div class="container-fluid pt-5">
      <action-dispatcher action="modules/getLastLessons">
        <last-lessons
          :data="lastLessons"
          :class="{ 'd-xl-none': isVideoBackground }"
        ></last-lessons>

        <h5 class="page-title pt-5 mb-3">Todos os módulos</h5>

        <home-carousel :list="sortedModules">
          <template #default="{ data }">
            <module-card class="flex-fill" :module="data" />
          </template>
        </home-carousel>

        <div v-for="(value, key) in modulesPerCategory" :key="key" class="pt-1">
          <h5 class="page-title my-3">{{ key }}</h5>

          <home-carousel :list="value">
            <template #default="{ data }">
              <module-card class="flex-fill" :module="data" />
            </template>
          </home-carousel>
        </div>

        <action-dispatcher action="releases/getReleases">
          <template v-if="releases.length">
            <div class="container-fluid px-0 mb-5">
              <home-carousel
                :list="releases"
                :per-page-custom="releases_per_page"
              >
                <template #default="{ data }">
                  <releases :release="data" class="mr-3" />
                </template>
              </home-carousel>
            </div>
          </template>

          <action-dispatcher action="courses/getRelated">
            <template v-if="relatedCourses.length">
              <div class="container-fluid px-0 mb-5">
                <h5 class="page-title mt-4">
                  Cursos relacionados
                </h5>

                <home-carousel
                  :list="relatedCourses"
                  :per-page-custom="[
                    [576, 2],
                    [768, 3],
                    [992, 4.3],
                    [1500, 4.9]
                  ]"
                >
                  <template #default="{ data }">
                    <related-course class="flex-fill" :course="data" />
                  </template>
                </home-carousel>
              </div>
            </template>

            <final-quiz-available />
          </action-dispatcher>
        </action-dispatcher>
      </action-dispatcher>
    </div>
  </div>
</template>

<script>
import FinalQuizAvailable from "@/components/quiz/FinalQuizAvailable";
import HeaderPreview from "@/components/preview/HeaderPreview";
import RelatedCourse from "@/components/home/RelatedCourse";
import HomeCarousel from "@/components/home/HomeCarousel";
import LastLessons from "@/components/home/LastLessons.vue";
import ModuleCard from "@/components/home/ModuleCard";
import { humanized_minutes } from "@/functions/helpers";
import Releases from "@/components/home/Releases";
import { mapState } from "vuex";
import get from "lodash/get";
import isMobile from "ismobilejs";

export default {
  components: {
    FinalQuizAvailable,
    RelatedCourse,
    HeaderPreview,
    HomeCarousel,
    ModuleCard,
    LastLessons,
    Releases
  },
  computed: {
    ...mapState("modules", ["modules", "lastLessons", "module", "categories"]),
    ...mapState("courses", ["relatedCourses"]),
    ...mapState("releases", ["releases"]),
    ...mapState("user", ["course_info"]),
    ...mapState("lessons", ["lessons"]),
    ...mapState(["setup"]),
    course_data() {
      return {
        name: this.course_info?.name_course,
        ...this.$setup.setup
      };
    },
    sortedModules() {
      return [...this.modules].sort((a, b) => a.sort - b.sort);
    },
    modulesPerCategory() {
      return [...this.categories]
        .filter(c => c)
        .sort((a, b) => a.sort - b.sort)
        .reduce((acc, cur) => {
          const modules = this.modules.filter(
            m => m.categories.find(c => c.id == cur.id) || m?.category == cur.id
          );

          if (modules.length) {
            acc[cur.name] = modules;
          }

          return acc;
        }, {});
    },
    all_module_duration() {
      if (!this.modules || this.modules.length == 0) return 0;

      return this.modules.reduce((acc, cur) => acc + Number(cur.duration), 0);
    },
    additionalInfo() {
      const time = get(
        this.course_info,
        "hourly_load",
        this.all_module_duration
      );

      const duration =
        time > 0 ? `${humanized_minutes(time)} de duração • ` : "";

      return `${duration}${this.modules.length} módulos`;
    },
    lastLesson() {
      if (this.lastLessons.length) return this.lastLessons[0];

      if (this.lessons.length) return this.lessons[0];

      return null;
    },
    releases_per_page() {
      return [
        [200, 1],
        [450, 1.5],
        [768, 2],
        [992, 1],
        [1250, this.releases.length == 1 ? 1 : 1.3]
      ];
    },
    videoURL() {
      if (isMobile().any) {
        return this.course_data.link_video_mobile;
      }

      return this.course_data.link_video;
    },
    isVideoBackground() {
      return this.course_data.cover_view_type === "video" && this.videoURL;
    }
  },
  mounted() {
    this.$store.dispatch("user/getCertificateStatus");
    this.$store.dispatch("lessons/getAll", this.modules[0].id);
    this.$store.dispatch("modules/getCategories").then();
  }
};
</script>

<style lang="scss" scoped>
.view-home {
  ::v-deep .VueCarousel {
    .VueCarousel-pagination {
      padding-right: 18px;
      position: absolute;
      top: -12%;
      left: 90%;
      transform: translateX(-90%);
      text-align: right;
    }
  }
}
.animated {
  animation: fadeInAnimation ease 6s;
  animation-iteration-count: 1;
  animation-fill-mode: forwards;
}
@keyframes fadeInAnimation {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
</style>
